import axios from "axios";
import baseURL from "../components/utils/baseURL.js"

class UploadFileService {
    getFiles(token) {
        return axios.get(`${baseURL}/uploaded-file`, {
            headers: {
                Authorization: "Bearer " + token
            }
        });
    }

    uploadFile(token, data) {
        return axios.post(`${baseURL}/uploaded-file/upload`, data, {
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "multipart/form-data"
            }
        });
    }

    toggleStatus(token, data) {
        return axios.post(`${baseURL}/uploaded-file/toggle`, data, {
            headers: {
                Authorization: "Bearer " + token
            }
        });
    }

    editFile(token, id, data) {
        return axios.put(`${baseURL}/uploaded-file/${id}`, data, {
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "multipart/form-data"
            }
        });
    }

    deleteFile(token, id) {
        return axios.delete(`${baseURL}/uploaded-file/${id}`, {
            headers: {
                Authorization: "Bearer " + token
            }
        });
    }
}

const uploadFileService = new UploadFileService();
export default uploadFileService;
